import React from 'react';
import { brandClasses } from '../../theme';
import { IconButton } from './IconButton';

export interface ModalHeaderProps {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  onClose?: () => void;
  closeAriaLabel?: string;
  className?: string;
  contentClassName?: string;
  surfaceClassName?: string;
  closeButtonClassName?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  eyebrow,
  title,
  description,
  onClose,
  closeAriaLabel = 'Close modal',
  className = '',
  contentClassName = '',
  surfaceClassName = brandClasses.titleBarSurface,
  closeButtonClassName = '',
  actions,
  children,
}) => {
  return (
    <div
      className={`relative border-b px-6 py-5 pe-20 ${brandClasses.subtleBorder} ${surfaceClassName} ${className}`.trim()}
    >
      {onClose ? (
        <IconButton
          type="button"
          onClick={onClose}
          className={`absolute end-4 top-3 ${closeButtonClassName}`.trim()}
          aria-label={closeAriaLabel}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </IconButton>
      ) : null}
      <div className={`flex items-start justify-between gap-4 ${contentClassName}`.trim()}>
        <div className="min-w-0">
          {eyebrow ? (
            <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-[#185FA5]">{eyebrow}</p>
          ) : null}
          <div className={eyebrow ? 'mt-1' : ''}>
            {typeof title === 'string' ? (
              <h2 className="font-['Playfair_Display',Georgia,serif] text-[28px] font-semibold text-[#1A1714]">{title}</h2>
            ) : (
              title
            )}
          </div>
          {description ? <p className="mt-1 text-sm text-[#6B6560]">{description}</p> : null}
          {children}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
};
